import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function FeaturedPost() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-377">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-378">
        <AnimateOnScroll data-id="element-379">
          <div className="bg-white shadow-[0_8px_30px_rgba(0,0,0,0.08)] overflow-hidden flex flex-col lg:flex-row" data-id="element-380">
            {/* Image */}
            <div className="w-full lg:w-[55%] relative" data-id="element-381">
              <img src="https://images.unsplash.com/photo-1629909613654-28e377c37b09?w=800&h=600&fit=crop" alt="Welcome to Be Clinical" className="w-full h-[250px] sm:h-[300px] lg:h-full object-cover" data-id="element-382" />
            </div>

            {/* Content */}
            <div className="w-full lg:w-[45%] p-6 sm:p-8 lg:p-12 flex flex-col justify-center" data-id="element-383">
              <span className="text-[#FF1493] uppercase text-xs font-bold tracking-[2px] mb-4 font-[Poppins,_sans-serif]" data-id="element-384">
                FEATURED
              </span>

              <h2 className="text-black font-bold text-2xl lg:text-[32px] leading-[1.3] mb-3 font-[Poppins,_sans-serif]" data-id="element-385">
                Welcome to Be Clinical
              </h2>

              <p className="text-[#999999] text-sm font-[Poppins,_sans-serif] mb-4" data-id="element-386">
                January 10, 2025
              </p>

              <p className="text-[#333333] text-base leading-[1.6] font-body mb-6 line-clamp-4" data-id="element-387">
                We are excited to have you here! Be CLINICAL is the integrated
                medicine and aesthetics practice of Fiona Frie, MD. As an
                internist, double-trained in both the UK and the US, Dr. Frie
                has made it her goal as a physician to help her patients live
                their best lives possible.
              </p>

              <a href="#" className="text-[#FF1493] uppercase text-sm font-bold tracking-widest hover:underline font-[Poppins,_sans-serif] inline-flex items-center gap-2" data-id="element-388">
                READ MORE <span data-id="element-389">→</span>
              </a>
            </div>
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}